<template>
    <div class="container-fluid fixWidth">
        <snackbar :snacksProp="snackBar" />
        <v-data-table
            :headers="headers"
            :items="getUserTypeItem"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :footer-props="pagination.rowsPerPageItems">
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>User Type List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
        <template v-slot:no-data>
            <div>No Data Found</div>
        </template>
        </v-data-table>
    </div>
</template>

<script>
import snackbar from "@/components/utils/snackbar.vue";
import functionalMixin from "../../mixins/searchFunction";

export default {
    components: {
        snackbar,
    },
  mixins: [
    functionalMixin
  ],
    data(){
        return{
            pagination: {
                itemsPerPage: 10,
                rowsPerPageItems: { "items-per-page-options": [5, 10, 25, 100, 200] },
            },
            totalItems: 3,
            headers: [
                { text: "Serial No.", value: "id", sortable: false},
                { text: "Title", value: "title", sortable: false },
            ],
            snackBar: {
        control: false,

        multiline: true,
        text: {
          message: "",
        },
      },
        }
    },
    computed: {
        getUserTypeItem(){
            return this.$store.getters.getUserTypeItem;
        }
    },
    watch: {
        pagination() {
            this.searchUserType();
        },
    },
    methods: {
        searchUserType(){
            this.$store.dispatch('callUserTypeData', {
                page: this.pagination.page,
                size: this.pagination.itemsPerPage,
            }).then((res)=>{

            })
        }
    }
}
</script>

<style scoped>
.v-data-table th {
  font-size: 14px !important;
}
</style>